<!-- 注册审批 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form :inline="false"
             :model="dataForm" ref="dataForm">
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名">
            <el-input disabled v-model="dataForm.userName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="jobCode"
                        label="岗位">
            <el-select disabled
                       v-model="dataForm.jobCode">
              <el-option v-for="(item,index) in jobCodeArr"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="经销商">
            <el-input disabled v-model="dataForm.orgName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="课程名称">
            <el-input disabled v-model="dataForm.courseName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排期编号">
            <el-input disabled v-model="dataForm.offeringNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排期场地">
            <el-input disabled v-model="siteNameAndClassnameAndType"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="开始时间">
            <el-input disabled v-model="dataForm.offeringStartDate"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结束时间">
            <el-input disabled v-model="dataForm.offeringEndDate"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排期名称">
            <el-input disabled v-model="dataForm.offeringName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否开启等候名单">
            <el-input disabled v-model="dataForm.waitingListFlag === '10' ? '是':'否'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否满员">
            <el-input disabled v-model="dataForm.isFullStaffed === '10' ? '是':'否'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请/分配时间">
            <el-input disabled v-model="dataForm.applyDate"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="排期价格(元)">
            <el-input disabled :value="formatMoney(dataForm.coursePrice)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="可用余额(元)">
            <el-input disabled :value="formatMoney(accountBalance)">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
import Vue from 'vue'
export default {
  data () {
    return {
      dataForm : {
        siteNameAndClassnameAndType:''
      },
      isDeduction:false,
      isDealer:'',
      accountBalance: '',
      siteNameAndClassnameAndType:'',
      registerOfferingId: undefined,
      jobCodeArr: []
    }
  },
  computed: {
  },
  // userRole hradminAudit 第一步审批 areaAudit 第二步审批
  created () {
    // 接收广播
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_UPCOMING, (data) => {
      this.initialization()
    })
  },
  mounted () {
    this.initialization()
  },
  methods: {
    // 页面初始化
    initialization () {
      this.registerOfferingId = undefined
      if (this.$route.query.registerOfferingId !== undefined) {
        this.registerOfferingId = this.$route.query.registerOfferingId
        this.queryPosition()
        this.getRegisterOffering()

      }
    },
    getRegisterOffering () {
      this.$request.post(`/learning/offeringregiste/info`,{registeId: this.registerOfferingId}).then((res, total, code, data) => {
        this.dataForm = data.data
        // this.dataForm.siteNameAndClassnameAndType = data.data.siteName
        // if (data.data.siteClassNameCn) {
        //   this.dataForm.siteNameAndClassnameAndType = this.dataForm.siteNameAndClassnameAndType + ',' + data.data.siteClassNameCn
        // }
        // if (data.data.cityName) {
        //   this.dataForm.siteNameAndClassnameAndType = this.dataForm.siteNameAndClassnameAndType + ',' + data.data.cityName
        // }

        this.queryResources(data.data.offeringId)
        this.getDataListBalance(data.data.offeringId,data.data.userId)
          // var siteNameAndClassnameAndType =
          // this.siteNameAndClassnameAndType = siteNameAndClassnameAndType

      }).catch((err) => {
        console.error(err);
      })



    },
    queryPosition () {
      this.$request.get('/talent/position/queryCommPosition', {}).then((res, total, code, data) => {
        this.jobCodeArr = data.data
      }).catch((error) => {
        console.error(error)
      })
    },
    queryResources(offeringId) {
      this.$request.get('/learning/offeringResources/getResources',
        {offeringId: offeringId}
      ).then((res, total, code, data) => {
        console.log(data)
        if (data.data !== 'undefined' && data.data !== null) {
          console.log('11111')
          if (data.data) {
            console.log('2222')
            var siteNameAndClassnameAndType = data.data.offeringInfoDto.siteName
            if (data.data.offeringInfoDto.siteClassNameCn) {
              siteNameAndClassnameAndType = siteNameAndClassnameAndType + ',' + data.data.offeringInfoDto.siteClassNameCn
            }
            if (data.data.offeringInfoDto.cityName) {
              siteNameAndClassnameAndType = siteNameAndClassnameAndType + ',' + data.data.offeringInfoDto.cityName
            }
            this.siteNameAndClassnameAndType = siteNameAndClassnameAndType
            this.dataForm.coursePrice=data.data.offeringInfoDto.coursePrice
            // return siteNameAndClassnameAndType;
          }
        }
      }).catch(() => {
        // this.$message('444')
      })
    },
   // 追加查询账户余额接口
    getDataListBalance (offeringId,userId) {
      // 根据排期 YIXIAN.ZHU 查询 母店所属金额
      //let offeringIds='1407529998963765249'
      //console.log(offeringId+">>>222222>>>>>>>>"+offeringIds)
      this.$request.get(
              '/learning/finance/queryDealerAccountAndFree',
              {
                offeringId: offeringId,
                userId: userId
              }
      ).then((res, total, code, data) => {
        // availableBalance:3900,//汇总金额
        // unfreezeBalance:100,//欲解冻余额
        // accountBalance:3800//账户余额
        let codes=data.code
        console.log(">>>>>>>>>>>"+1407529998963765249)
        if(codes==1){ //有账户时
          // this.dataofferinginfo.availableBalance = data.data.availableBalance
          // this.dataofferinginfo.unfreezeBalance = data.data.unfreezeBalance
          // this.dataofferinginfo.accountBalance = data.data.accountBalance
          // this.availableBalance = data.data.availableBalance
          // 账户余额
          this.accountBalance = data.data.accountBalance
          // 是否减免
          if(data.data.isFree){
            this.isDeduction = data.data.isFree
          }
          this.isDealer =data.data.isDealer
          //
        }
        console.info('this.registeredDataList----------->>>', this.dataForm.accountBalance)
      }).catch(() => {
        this.dataListLoading = false
        this.isClose = true
      })
    },
    /**
     * 将数值四舍五入(保留2位小数)后格式化成金额形式
     *
     * @param num 数值(Number或者String)
     * @return 金额格式的字符串,如'1,234,567.45'
     * @type String
     */
    formatMoney(num) {
      if (!num && (num !== 0 && num !== '0')) {
        return ""
      }
      num = num.toString().replace(/\$|\,/g,'');
      if(isNaN(num)) {
        num = "0";
      }
      let sign = (num == (num = Math.abs(num)));
      num = Math.floor(num*100+0.50000000001);
      let cents = num%100;
      num = Math.floor(num/100).toString();
      if(cents<10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++) {
        num = num.substring(0,num.length-(4*i+3))+','+ num.substring(num.length-(4*i+3));
      }
      return (((sign)?'':'-') + num + '.' + cents);
    }
  }
}
</script>
<style type="text/css" scoped>
</style>
